import React, { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import { CardSessionStatus } from "./CompUI";
import CardCurrentSectionHorizontal from "../widgets/CardCurrentSectionHorizontal";
import { TableSession } from "./TableSession";
import LoadingBtn from "../../../../Widgets/LoadingBtn";
import { AlertNotif } from "../../../../../Library/AlertNotif";
import { GET_ATD_LECTURER_BY_SECTION } from "../../../APIS";
import { FormSubmitAtd } from "./FormSubmitAtd";
import { FormAtdStudents } from "./FormAtdStudents";

const AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];
export function DSession({ section, status, start_dt }) {
  const [actvSession, setActvSession] = useState(status ? status : 2);
  const [sesClass, setSesClass] = useState({
    loading: false,
    data: [],
    message: "",
  });

  const ReloadDataSession = async () => {
    setSesClass({ loading: true, data: [], message: "" });
    const param = {
      empid: AuthDecode.currentData.entityid,
      section_id: section.section_id,
      status: actvSession,
    };

    const results = await GET_ATD_LECTURER_BY_SECTION(param);
    setSesClass(results);
  };

  const [selectedAtdid, setSelectedAtdid] = useState();

  useEffect(() => {
    ReloadDataSession();
  }, [actvSession, selectedAtdid]);

  useEffect(() => {
    //BACK HANDLER
    const handleBackButton = (event) => {
      event.preventDefault();
      setSelectedAtdid(null);
    };

    window.history.pushState(null, null, window.location.href);

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
    //END BACK
  }, [selectedAtdid]);

  return (
    <div className="d-sessions">
      <div className="card card-custome gutter-b">
        <div className="card-header bg-light py-0 px-5">
          <CardCurrentSectionHorizontal sections={section} />
        </div>
        <div className="card-body pt-5 px-0 pb-0">
          {selectedAtdid && Object.values(selectedAtdid).length > 0 ? (
            <>
              <FormSubmitAtd data={selectedAtdid} setSelectedAtdid={setSelectedAtdid} />
              <FormAtdStudents data={selectedAtdid} Reload={ReloadDataSession} />
            </>
          ) : (
            <>
              <div className="px-8">
                <CardSessionStatus data={actvSession} setData={setActvSession} />
              </div>
              {sesClass.loading ? (
                <LoadingBtn />
              ) : sesClass.message ? (
                <AlertNotif message={sesClass.message} color="danger" />
              ) : (
                <TableSession
                  data={sesClass.data}
                  setSelectedAtdid={setSelectedAtdid}
                  start_dt={start_dt}
                />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
